import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenClip } from "@fortawesome/free-solid-svg-icons";

import { useTranslation } from "react-i18next";

const ReviewStartBtn = (props) => {
    const {t} = useTranslation(['page']);
    return (
        <div className={"review-start-wrapper"}>
            {props.reviewing ? (
                <button
                    className={`review-start-btn active`}
                    onClick={() => {
                        
                        props?.setReviewing && props.setReviewing(false);
                    }}
                >
                    <span className={"active"}>
                        In-progress
                        <div className={"float"}>
                            <span className={"dot"}>.</span>
                            <span className={"dot"}>.</span>
                            <span className={"dot"}>.</span>
                            <span className={"dot"}>.</span>
                            <span className={"dot"}>.</span>
                            <span className={"dot"}>.</span>
                        </div>
                    </span>
                    <span className={"inactive"}>Cancel</span>
                </button>
            ) : (
                <button
                    className={`review-start-btn`}
                    onClick={() => {
                        props?.setReviewing && props.setReviewing(true);
                    }}
                >
                    <FontAwesomeIcon icon={faPenClip} />
                    {t("reviewstartbtn")}
                </button>
            )}
        </div>
    );
};

export default ReviewStartBtn;
